import { CheckCircle2 } from "lucide-react";
import { Icon } from "../../lib/icons";
import { moneyShort, shortDate } from "../../lib/format";

export const tierNote = (t) => (t?.last_day ? `${t.label} – ends ${shortDate(`${t.last_day}T12:00:00`)}` : t?.label || "");

export default function StepCategory({ categories, form, set, errors, invite, testCard = null }) {
  const selected = categories.find((c) => c.id === form.category_id);
  const needsCode = !invite && selected && ["code", "code_or_approval"].includes(selected.complimentary_rule);
  return (
    <fieldset data-testid="step-attendee-type">
      <legend className="text-2xl text-navy"><span className="text-burgundy">1.</span> Attendee Type</legend>
      <p className="mt-1 text-[#4A5568]">Select the category that best describes you.</p>
      <div className="mt-5 grid grid-cols-2 gap-4 lg:grid-cols-4" role="radiogroup" aria-label="Attendee type">
        {categories.map((c) => {
          const on = c.id === form.category_id;
          return (
            <button key={c.id} type="button" role="radio" aria-checked={on} onClick={() => set({ category_id: c.id, comp_code: "", ...(invite ? {} : { invite_code: "" }) })}
              data-testid={`category-card-${c.key}`}
              className={`relative flex flex-col items-center rounded-lg border-2 bg-white p-5 text-center transition-colors duration-200 ${on ? "border-burgundy bg-[#FEF3F3]" : "border-slate-200 hover:border-slate-400"}`}>
              {on && <CheckCircle2 className="absolute right-2 top-2 text-burgundy" size={22} fill="#fff" aria-hidden="true" />}
              <Icon name={c.icon} size={28} className="text-navy" />
              <span className="mt-2 font-semibold text-navy">{c.name}</span>
              <span className="mt-1 text-xs text-[#4A5568]">
                {invite ? "Complimentary (invitation)" : c.complimentary_rule !== "none" ? "Complimentary eligible"
                  : c.current_tier ? moneyShort(c.current_tier.price, c.currency) : `From ${moneyShort(Math.min(...(c.attendance_modes || ["in_person", "virtual"]).map((m) => c.prices[m])), c.currency)}`}
              </span>
              {!invite && c.current_tier && <span className="mt-1 rounded bg-gold/20 px-2 py-0.5 text-xs font-semibold text-navy" data-testid={`category-tier-${c.key}`}>{tierNote(c.current_tier)}</span>}
            </button>
          );
        })}
        {testCard}
      </div>
      {errors.category_id && <p className="field-error" role="alert">{errors.category_id}</p>}
      {selected && (
        <div className="mt-5 rounded-lg bg-paleblue p-4 text-sm text-navy" data-testid="category-eligibility">
          <p>{selected.description}</p>
          {selected.eligibility_note && <p className="mt-1 font-semibold">{selected.eligibility_note}</p>}
          {selected.is_sample_price && <p className="mt-1 text-[#4A5568]">Prices shown are sample prices pending confirmation.</p>}
        </div>
      )}
      {needsCode && (
        <div className="mt-5 max-w-sm">
          <label htmlFor="comp_code" className="field-label">Complimentary code {selected.complimentary_rule === "code" ? "(optional; otherwise standard price applies)" : "(optional; otherwise subject to admin approval)"}</label>
          <input id="comp_code" className="field-input uppercase" value={form.comp_code} onChange={(e) => set({ comp_code: e.target.value })} data-testid="comp-code-input" />
        </div>
      )}
    </fieldset>
  );
}
